module.exports = __webpack_public_path__ + "img/alegeus.e4008cf8.png";